import { ojs } from "modular-openscriptjs";
import { Analytics } from "./Analytics";
import { AnnouncementMediator } from "./AnnouncementMediator";
import { Auth } from "./Auth";
import { Award } from "./Award";
import { BusinessRating } from "./BusinessRating";
import { Capa } from "./Capa";
import { Cart } from "./Cart";
import { CommentMediator } from "./Comment";
import { DeliveryAddress } from "./DeliveryAddress";
import { ErrandMediator } from "./ErrandMediator";
import { LocationMediator } from "./Location";
import { MentionMediator } from "./Mention";
import { Order } from "./Order";
import { Payment } from "./Payment";
import { PaymentRequest } from "./PaymentRequest";
import { Product } from "./Product";
import { QRCode } from "./QRCode";
import { Review } from "./Review";
import { Setting } from "./Setting";
import { Surplus } from "./Surplus";
import { User } from "./User";
import { Utility } from "./Utility";
import CapaPayment from "./PaymentMethods/CapaPayment";
import MpesaPayment from "./PaymentMethods/MpesaPayment";
import OfflineMpesaPayment from "./PaymentMethods/OfflineMpesaPayment";
import System from "./System";
import { AiCredit } from "./AiCredit";
import { SubscriptionMediator } from "./SubscriptionMediator";
import { DeliveryRequest } from "./DeliveryRequest";
import { VoiceOrderCall } from "./VoiceOrderCall";

ojs(
	System,
	Analytics,
	AnnouncementMediator,
	Auth,
	Award,
	BusinessRating,
	Capa,
	Cart,
	CommentMediator,
	DeliveryAddress,
	ErrandMediator,
	LocationMediator,
	MentionMediator,
	Order,
	Payment,
	PaymentRequest,
	Product,
	QRCode,
	Review,
	Setting,
	Surplus,
	User,
	Utility,
	CapaPayment,
	MpesaPayment,
	OfflineMpesaPayment,
	AiCredit,
	SubscriptionMediator,
	DeliveryRequest,
	VoiceOrderCall,
);
